import { RootState } from '../../store/store';

const loadingSelector = (state: RootState): boolean => state.api.loading;

export default loadingSelector;
